<template>
    <div id="tabs" :class="{desktop: !isMobile, mobile: isMobile}">
        <a v-for="item in items"class="tab" :class="{selected: item.selected}"
            :key="item.id"
            @click="onClick(item)">
            {{ item.title }}
        </a>
    </div>
</template>
<script>
export default {
    name: "Tabs",
    props: {
        isMobile:{
            type:Boolean,
            default:false
        },
        items:{
            type: Array,
            default: null
        }
    },
    // data() {
    //     return {};
    // },
    // mounted() {
    // },
    // computed: {},
    methods: {
        onClick(item){
            this.$emit('tabClicked', item);
        }
    },
};
</script>
<style lang="scss">
#tabs{
    display: flex;
    flex-direction: row;
    padding-bottom: 22px;
    gap: 8px;

    .tab{
        background:#fff;
        padding: 8px 16px;
        border-radius: 20px;
        height: 30px;
        cursor: pointer;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        display: flex;
        align-items: center;
        text-wrap-mode: nowrap;
    }  
    
    .tab.selected{
        background: #333;
        color: #fff;
    }    

    &.mobile{
        overflow-x: scroll;
        margin: 0 16px;
    }    
}

</style>
